import type { GameObj } from "kaplay";
import { screenCenter } from "../components/screenCenter";
import { COLORS } from "../config/constants";
import { k } from "../core/kaplay";

export function addUiRoot() {
    return k.add([k.pos(k.center()), k.scale(1), k.fixed(), k.layer("ui"), screenCenter()]);
}

export function addTitle(parent: GameObj, text: string, y: number, size = 96) {
    return parent.add([k.text(text, { size }), k.pos(0, y), k.anchor("center"), k.color(COLORS.uiText)]);
}

export function addButton(parent: GameObj, label: string, y: number, onPress: () => void, enabled = true) {
    const base = k.Color.fromHex(enabled ? COLORS.ui : "#6b6b6b");
    const button = parent.add([
        k.rect(520, 96, { radius: 16 }),
        k.pos(0, y),
        k.anchor("center"),
        k.color(base),
        k.outline(4, k.rgb(0, 0, 0)),
        k.area(),
        "button",
    ]);
    button.add([k.text(label, { size: 40 }), k.anchor("center"), k.color(COLORS.uiText)]);

    if (enabled) {
        button.onClick(onPress);
        button.onHover(() => (button.color = base.lighten(40)));
        button.onHoverEnd(() => (button.color = base));
    }
    return button;
}
